/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface AufgabenControllerUnlinkDokumentV1$Params {
  id: number;
  uploadID: string;
}

export function aufgabenControllerUnlinkDokumentV1(http: HttpClient, rootUrl: string, params: AufgabenControllerUnlinkDokumentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerUnlinkDokumentV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('uploadID', params.uploadID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

aufgabenControllerUnlinkDokumentV1.PATH = '/v1/aufgaben/{id}/dokumente/{uploadID}';
